import * as React from 'react';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/system';
import { baseModalDialogContentSx } from 'styles/sx/dialogSx';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';

const StyledDialogContent = styled(DialogContent)(({ theme }) => {
  const baseDialogContentStyles =
    baseModalDialogContentSx?.['&.MuiDialogContent-root'] ?? {};

  return {
    '&.MuiDialogContent-root': {
      ...baseDialogContentStyles
    },
    backgroundColor: getPageBackgroundColor(theme),
    height: '100%'
  };
});

export function ModalDialogContent(props) {
  return <StyledDialogContent {...props} />;
}
